module.exports = __webpack_public_path__ + "static/media/SectionPartners_lg_science_park.bad57d71.png";